import { AxiosInstance, AxiosResponse } from "axios";
import { CompanyReportModel } from "@/models/CompanyReportModel";
import WorkerReportModel from "@/models/WorkerReportModel";

export default class ReportService {
  private axiosInstance: AxiosInstance;

  public constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  public async getCompanyReport(start: Date, end: Date): Promise<CompanyReportModel[]> {
    const url = `/CompanyReport/${start.getFullYear()}-${start.getMonth() +
      1}-${start.getDate()}/${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`;
    const res: AxiosResponse<CompanyReportModel[]> = await this.axiosInstance.get<CompanyReportModel[]>(url);
    return res.data;
  }

  public async getWorkerReport(data: object): Promise<WorkerReportModel[]> {
    const url = `/CompanyReport/workers`;
    const res: AxiosResponse<WorkerReportModel[]> = await this.axiosInstance.post<WorkerReportModel[]>(url, data);
    return res.data || [];
  }
}
